export const ORDERS_API = 'https://65ed7a9908706c584d99d718.mockapi.io/orders';
export const ITEMS_API = 'https://650f314454d18aabfe99ec68.mockapi.io/items';
